import FetchData from '@ezviz/FetchData';
import moment from "moment";
import { message } from "antd";
import util from './../../utils/utils';
import intl from 'react-intl-universal';

import { fetchApplicationDetailInfo } from './application';

// IOS推送证书配置
export const FETCH_APPLICATION_IOS_CERTIFICATE_LOADING = 'FETCH_APPLICATION_IOS_CERTIFICATE_LOADING';
export const FETCH_APPLICATION_IOS_CERTIFICATE_SUCCESS = 'FETCH_APPLICATION_IOS_CERTIFICATE_SUCCESS';
export const FETCH_APPLICATION_IOS_CERTIFICATE_FAILED = 'FETCH_APPLICATION_IOS_CERTIFICATE_FAILED';
// Android推送基础配置
export const FETCH_APPLICATION_ANDROID_PUSH_BASE_LOADING = 'FETCH_APPLICATION_ANDROID_PUSH_BASE_LOADING';
export const FETCH_APPLICATION_ANDROID_PUSH_BASE_SUCCESS = 'FETCH_APPLICATION_ANDROID_PUSH_BASE_SUCCESS';
export const FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED = 'FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED';
// Android推送产商配置
export const FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_LOADING = 'FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_LOADING';
export const FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_SUCCESS = 'FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_SUCCESS';
export const FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_FAILED = 'FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_FAILED';
// 正式打包前校验配置信息接口
export const FETCH_APPLICATION_ANDROID_CHECK_LOADING = 'FETCH_APPLICATION_ANDROID_CHECK_LOADING';
export const FETCH_APPLICATION_ANDROID_CHECK_SUCCESS = 'FETCH_APPLICATION_ANDROID_CHECK_SUCCESS';
export const FETCH_APPLICATION_ANDROID_CHECK_FAILED = 'FETCH_APPLICATION_ANDROID_CHECK_FAILED';

// 设置校验Modal显示
export const SET_CHECK_MODAL_VISIBLE = 'SET_CHECK_MODAL_VISIBLE';
export const SET_VERSION_MODAL_VISIBLE = 'SET_VERSION_MODAL_VISIBLE';
export const SET_PAGEVIEW = 'SET_PAGEVIEW';


moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

// IOS应用证书配置
export function fetchApplicationIOSCertificate(param = {}, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const {
      iosPolicyInfo,
      mobileProvision,
      iosPolicyPassword,
    } = param;
    const body = {
      appId,
      iosPolicyInfo,
      mobileProvision,
      iosPolicyPassword,
    }
    dispatch({
      type: FETCH_APPLICATION_IOS_CERTIFICATE_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/app/certificate/config`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_IOS_CERTIFICATE_SUCCESS,
          });
          message.info(intl.get('home.product.feature.saveSuccess'));
          dispatch(fetchApplicationDetailInfo({}, () => {
            callback && callback();
          }));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_IOS_CERTIFICATE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_IOS_CERTIFICATE_FAILED,
        });
      });
  };
}
// IOS推送证书配置
export function fetchApplicationIOSPushCertificate(param = {}) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const { iosPushFile, iosPushPassword } = param;
    const formdata = new FormData;
    formdata.append('multipartFile', iosPushFile)
    formdata.append('appId', appId)
    formdata.append('certificateType', 0)
    formdata.append('password', iosPushPassword)

    dispatch({
      type: FETCH_APPLICATION_IOS_CERTIFICATE_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/config/push/ios/certificate`, {
      method: 'POST',
      headers: {
        appId,
      },
      body: formdata,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_IOS_CERTIFICATE_SUCCESS,
          });
          message.info(intl.get('home.product.feature.saveSuccess'));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_IOS_CERTIFICATE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_IOS_CERTIFICATE_FAILED,
        });
      });
  };
}

// Android推送基础配置
export function fetchApplicationAndroidPushBase(param = {}) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const {
      androidPushTitle = '',
      androidClickComponent = '',
      androidChannelId = ''
    } = param;
    const body = {
      androidPushTitle,
      androidClickComponent,
      androidChannelId,
      enableAndroidPush: true,
      appId,
    }
    dispatch({
      type: FETCH_APPLICATION_ANDROID_PUSH_BASE_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/config/push/android/base`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_BASE_SUCCESS,
          });
          message.info(intl.get('home.product.feature.saveSuccess'));
          dispatch(fetchApplicationDetailInfo());
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED,
        });
      });
  };
}
// Android推送海外配置
export function fetchApplicationAndroidPushFcm(param = {}, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const { androidName } = getState().application.applicationDetail;
    const {
      fcmDatabaseUrl = '',
      fcmSecurityJson = '',
      googleService,
    } = param;
    // const formdata = new FormData;
    // formdata.append('appId', appId)
    // formdata.append('googleService', googleService)
    // formdata.append('fcmDatabaseUrl', fcmDatabaseUrl)
    // formdata.append('fcmSecurityJson', fcmSecurityJson)
    // formdata.append('packageName', androidName)
    const body = {
      appId,
      fcmDatabaseUrl,
      fcmSecurityJson,
      googleService,
      packageName: androidName,
    }

    dispatch({
      type: FETCH_APPLICATION_ANDROID_PUSH_BASE_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v2/config/push/android/fcm`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_BASE_SUCCESS,
          });
          message.info(intl.get('home.product.feature.saveSuccess'));
          dispatch(fetchApplicationDetailInfo({}, () => {
            callback && callback();
          }));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_ANDROID_PUSH_BASE_FAILED,
        });
      });
  };
}
// Android推送各产商配置
export function fetchApplicationAndroidPushInternal(param = {}, callback) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    const {
      pushAndroidOppoConfig,
      pushAndroidVivoConfig,
      pushAndroidHuaweiConfig,
      pushAndroidXiaomiConfig,
    } = param;
    const body = {
      appId,
      pushAndroidOppoConfig,
      pushAndroidVivoConfig,
      pushAndroidHuaWeiVo: pushAndroidHuaweiConfig,
      pushAndroidXiaomiConfig,
      pushAndroidFlymeConfig: {
        flymeAppId: "",
        flymeAppKey: "",
        flymeAppSecret: ""
      },
    }
    dispatch({
      type: FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/config/push/android/internal`, {
      method: 'POST',
      headers: {
        appId,
      },
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_SUCCESS,
          });
          message.info(intl.get('home.product.feature.saveSuccess'));
          dispatch(fetchApplicationDetailInfo({}, () => {
            callback && callback();
          }));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_ANDROID_PUSH_INTERNAL_FAILED,
        });
      });
  };
}

// 打包前校验
export function fetchApplicationCheck(param = {}) {
  return (dispatch, getState) => {
    const appId = window.applicationId;
    dispatch({
      type: FETCH_APPLICATION_ANDROID_CHECK_LOADING,
    });
    const fetchData = new FetchData(`/iot/config/api/iot/support/v1/app/change/info`, {
      method: 'GET',
      headers: {
        appId,
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_APPLICATION_ANDROID_CHECK_SUCCESS,
            changeInfo: res.data,
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: FETCH_APPLICATION_ANDROID_CHECK_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: FETCH_APPLICATION_ANDROID_CHECK_FAILED,
        });
      });
  };
}

// 设置校验Modal显示
export function setCheckModalVisible(param) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CHECK_MODAL_VISIBLE,
      guideCheckModalVisible: param
    });
  };
}

// 设置输入版本Modal显示
export function setVersionModalVisible(param) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_VERSION_MODAL_VISIBLE,
      versionModalVisible: param
    });
  };
}
// 设置输入版本Modal显示
export function setPageView(pageView) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_PAGEVIEW,
      pageView,
    });
  };
}


